<div class="d-flex align-items-center m-b-16">
  <button mat-stroked-button color="primary" type="button" [disabled]="!canResend" (click)="onResend()">
    {{ 'ABHA.RESEND_OTP' | translate }}
  </button>
  <span class="f-s-12 text-muted m-l-8" *ngIf="resendsLeft > 0 && secondsLeft > 0">
    {{ 'ABHA.RESEND_WAIT' | translate: { seconds: secondsLeft } }}
  </span>
  <span class="f-s-12 text-muted m-l-8" *ngIf="resendsLeft > 0 && secondsLeft === 0">
    {{ 'ABHA.RESEND_LEFT' | translate: { count: resendsLeft } }}
  </span>
  <span class="f-s-12 text-muted m-l-8" *ngIf="resendsLeft === 0">
    {{ 'ABHA.RESEND_LIMIT' | translate }}
  </span>
</div>
